import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=aa92f652&scoped=true"
import script from "./Tag.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tag.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Tag.vue?vue&type=style&index=0&id=aa92f652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa92f652",
  null
  
)

export default component.exports